import { PostPositionOrderResponseSchema } from '../order/post-position-order.ts';
import { z } from 'zod';
import { BILLING_TYPE_SCHEMA } from '../finance-settings/billing-types.ts';
import { BILLING_INTERVAL_SCHEMA } from '../billing-interval/billing-interval.ts';
import {
    ORDER_ORGANIZATION_ROLE_SCHEMA,
    ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA,
} from '../finance-settings/role.ts';

export const OrderPaymentOrganizationSchema = z.object({
    orderId: z.string().uuid(),
    organizationId: z.number().int().positive(),
    productId: z.string().uuid(),
    paymentTermId: z.number().positive().nullable(),
    billingMethod: BILLING_TYPE_SCHEMA,
    billingInterval: BILLING_INTERVAL_SCHEMA,
    transactionalRole: ORDER_ORGANIZATION_TRANSACTIONAL_ROLE_SCHEMA,
    functionalRole: ORDER_ORGANIZATION_ROLE_SCHEMA,
});

export type OrderPaymentOrganization = z.infer<typeof OrderPaymentOrganizationSchema>;

export const CreatePositionOrderInternalResponseSchema = PostPositionOrderResponseSchema.extend({
    paymentOrganizations: z.array(OrderPaymentOrganizationSchema),
});
